import React, { useMemo } from "react";

import InternalModal from "../../commons/InternalModal";

import Table from "./Table";
import KpiComposition from "./KpiComposition";

const columnsDefinition = (title) => [
  {
    id: "name",
    accessorKey: "name",
    header: () => <span>{title}</span>,
    cell: info => info.getValue() === "average"
      ? I18n.t("insights.page.table.average.title")
      : I18n.t(`insights.kpis.${info.getValue()}`),
    enableSorting: false
  },
  {
    id: "value",
    accessorKey: "value",
    header: () => <span>{I18n.t("insights.page.table.value.title")}</span>,
    cell: info => parseFloat(info.getValue()).toFixed(3),
    enableSorting: false
  },
  {
    id: "weight",
    accessorKey: "weight",
    header: () => <span>{I18n.t("insights.page.table.weight.title")}</span>,
    cell: info => <span>{info.getValue() && parseFloat(info.getValue()).toFixed(2)}</span>,
    enableSorting: false
  },
  {
    id: "result",
    accessorKey: "result",
    header: () => <span>{I18n.t("insights.page.table.result.title")}</span>,
    cell: info => <span>{info.getValue() && parseFloat(info.getValue()).toFixed(3)}</span>,
    enableSorting: false
  }
];

const makeTableData = (data) => [
  ...data?.kpis,
  {
    name: "average",
    value: data?.average,
    weight: data?.weight,
    result: data?.value,
    background: data?.background
  }
];

const TeamHealthScoreDetailsModal = ({ composition, onClose }) => {

  const teamHealthTitle = I18n.t("insights.page.table.team_health.title");
  const teamHealthColumns = useMemo(() => columnsDefinition(teamHealthTitle), []);

  const selfReportedTitle = I18n.t("insights.page.table.self_reported_metrics.title");
  const selfReportedColumns = useMemo(() => columnsDefinition(selfReportedTitle), []);

  const leadershipHealthTitle = I18n.t("insights.page.table.leadership_health.title");
  const leadershipHealthColumns = useMemo(() => columnsDefinition(leadershipHealthTitle), []);

  const renderContent = () => composition && (
    <div className="content">
      <Table
        columns={teamHealthColumns}
        data={makeTableData(composition?.team)}
        loading={false}
      />
      <Table
        columns={selfReportedColumns}
        data={makeTableData(composition?.self_reported)}
        loading={false}
      />
      <Table
        columns={leadershipHealthColumns}
        data={makeTableData(composition?.leadership)}
        loading={false}
      />
      <KpiComposition {...composition} />
    </div>
  );

  return (
    <InternalModal
      type="team-health-score-details"
      isModalOpen={Boolean(composition)}
      hideModal={onClose}
      showModalBody={false}
      component={renderContent()}
      backdrop
    />
  );
}

export default TeamHealthScoreDetailsModal;
